import { clamp, makeRng, pickObstacleType, makeObstacleDims } from './helpers'
import type { GameState } from './types'
import { PHYSICS_CONFIG, SPAWN_CONFIG } from './config'

const computeNextSpawnDelay = (gameState: GameState) => {
  const state = gameState
  const rng = makeRng((state.seed += 1))
  const speedFactor = clamp((state.speed - 230) / 520, 0, 1)
  const earlyFactor = clamp(state.score / 80, 0, 1)
  const earlyBoost = 0.35 * (1 - earlyFactor)
  const min = 0.9 + earlyBoost - speedFactor * 0.18
  const max = 1.65 + earlyBoost - speedFactor * 0.25
  return min + rng() * (max - min)
}

const spawnGroup = (gameState: GameState, width: number) => {
  const state = gameState
  const rng = makeRng((state.seed += 97))
  const early = state.score < SPAWN_CONFIG.earlyGameScoreThreshold
  const roll = rng()
  let count = 1
  // if (!early) {
  //   if (roll > 0.95) count = 3
  //   else
  if (roll > 0.75) { count = 2
  } else if (roll > 0.88) {
    count = 2
  }

  const speedFactor = clamp((state.speed - 245) / 520, 0, 1)
  const earlyFactor = clamp(state.score / 80, 0, 1)
  const baseMinGap = 160 + (1 - earlyFactor) * 60 + speedFactor * 30
  const minGapForGroup = baseMinGap + (count - 1) * 18
  state.minGapPx = clamp(minGapForGroup, 150, 250)

  const baseX = width + 40
  const lastObstacle = state.obstacles[state.obstacles.length - 1]
  const lastRight = lastObstacle ? lastObstacle.x + lastObstacle.w : -Infinity

  const lastGround = [...state.obstacles]
    .reverse()
    .find((o) => o.type !== 'hammer')
  let lastGroundRight = lastGround ? lastGround.x + lastGround.w : lastRight

  let x = Math.max(baseX, lastRight + state.minGapPx)

  for (let i = 0; i < count; i += 1) {
    const type = pickObstacleType(rng)
    const dims = makeObstacleDims(type, rng)

    if (type === 'hammer' && Number.isFinite(lastGroundRight)) {
      x = Math.max(x, (lastGroundRight ?? -Infinity) + PHYSICS_CONFIG.airGroundSafeGapPx)
    }

    const offsetY = type === 'hammer' ? 48 + rng() * 24 : 0
    const spinOffset = type === 'hammer' ? rng() * Math.PI * 2 : undefined

    state.obstacles.push({
      x,
      w: dims.w,
      h: dims.h,
      type,
      offsetY,
      spinOffset,
    })

    const gapJitter = 26 + rng() * 46
    const gap = Math.max(42, gapJitter + (1 - earlyFactor) * 14)
    if (type !== 'hammer') {
      lastGroundRight = x + dims.w
    }
    x += dims.w + gap
  }
}

export { computeNextSpawnDelay, spawnGroup }
